export enum PageType {
  AaaApplication = "AaaApplication",
  Landing = "Landing",
  ProgramSelection = "ProgramSelection",
  IdXboxApplication = "IdXboxApplication",
  PitchApplication = "PitchApplication",
  Error = "Error",
}
